export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
